/*
  Vorelisse — sonsuz ray (marquee) + elle sürükleme

  NEDEN JS:
  Saf CSS marquee (iki kopya + translateX(-50%)) yalnız içerik ekrandan GENİŞSE
  dikişsiz görünür. Dört maddelik bir güven şeridi geniş ekranda ~800px tutuyor,
  ekran 1440px olunca ray bir noktada boşalıyor ve "kesiliyor" gibi duruyordu.
  Burada kopya sayısı ekran genişliğine göre hesaplanıyor — hiçbir ekranda
  boşluk kalmıyor.

  Ayrıca kullanıcı rayı parmağıyla / fareyle sağa sola çekebiliyor; bıraktığında
  atalet ile yavaşlayıp otomatik akışa geri karışıyor. Akış hiç durmuyor,
  başa da dönmüyor: konum tek bir set genişliğine göre mod alınıyor.

  Kullanım:
    <div data-marquee data-speed="60" data-gap-drag="1">
      <div data-marquee-track>
        <ul data-marquee-set> ... </ul>
      </div>
    </div>

  data-speed : saniyede kaç piksel (varsayılan 55)
  data-pause-on-hover : "1" ise fare üstündeyken durur
*/
(function () {
  'use strict';

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var forced = document.documentElement.hasAttribute('data-force-motion');
  var autoAllowed = !reduced || forced;

  function init(root) {
    var track = root.querySelector('[data-marquee-track]');
    var set = root.querySelector('[data-marquee-set]');
    if (!track || !set) return;

    var speed = parseFloat(root.getAttribute('data-speed')) || 55;
    var pauseOnHover = root.getAttribute('data-pause-on-hover') === '1';

    var setWidth = 0;
    var offset = 0;
    var velocity = 0; // sürükleme bırakıldıktan sonraki atalet (px/sn)
    var dragging = false;
    var hovering = false;
    var pointerId = null;
    var lastX = 0;
    var lastT = 0;
    var moved = 0;

    /* Kopyalama: ray, görünür alanın iki katını aşana kadar set çoğaltılır.
       Böylece hangi konumda olursak olalım ekranda hep dolu içerik var. */
    function build() {
      // Önce eski kopyaları temizle (yeniden ölçümde birikmesin).
      var clones = track.querySelectorAll('[data-marquee-clone]');
      for (var i = 0; i < clones.length; i++) clones[i].remove();

      setWidth = set.getBoundingClientRect().width;
      if (!setWidth) return;

      var needed = Math.ceil((root.getBoundingClientRect().width * 2) / setWidth) + 1;
      for (var c = 0; c < needed; c++) {
        var copy = set.cloneNode(true);
        copy.setAttribute('data-marquee-clone', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.removeAttribute('data-marquee-set');
        track.appendChild(copy);
      }
    }

    // Konumu tek set genişliğine göre sarmala: iki yönde de sonsuz.
    function normalize() {
      if (!setWidth) return;
      offset = offset % setWidth;
      if (offset > 0) offset -= setWidth;
    }

    function draw() {
      track.style.transform = 'translate3d(' + offset + 'px,0,0)';
    }

    var last = 0;
    function loop(now) {
      requestAnimationFrame(loop);
      if (!last) last = now;
      var dt = Math.min((now - last) / 1000, 0.05);
      last = now;

      if (dragging) return;

      if (velocity) {
        // Bırakıldıktan sonra atalet; sürtünmeyle söner.
        offset += velocity * dt;
        velocity *= Math.pow(0.0025, dt);
        if (Math.abs(velocity) < 12) velocity = 0;
      } else if (autoAllowed && !(pauseOnHover && hovering)) {
        offset -= speed * dt;
      }

      normalize();
      draw();
    }

    /* --- Sürükleme ---------------------------------------------------------
       Yatay hareket rayı çeker; dikey hareket sayfayı kaydırmaya bırakılır
       (touch-action: pan-y). Bu yüzden ilk birkaç pikselde yön kararı verilir. */

    function onDown(e) {
      if (e.button !== undefined && e.button !== 0) return;
      dragging = true;
      velocity = 0;
      moved = 0;
      pointerId = e.pointerId;
      lastX = e.clientX;
      lastT = e.timeStamp || performance.now();
      root.classList.add('is-dragging');
      if (root.setPointerCapture && pointerId != null) {
        try { root.setPointerCapture(pointerId); } catch (err) { /* yut */ }
      }
    }

    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - lastX;
      var now = e.timeStamp || performance.now();
      var dt = (now - lastT) / 1000;

      offset += dx;
      moved += Math.abs(dx);
      if (dt > 0) velocity = dx / dt;

      lastX = e.clientX;
      lastT = now;
      normalize();
      draw();
    }

    function onUp() {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      // Aşırı hızlı fırlatmaları sınırla.
      velocity = Math.max(-2600, Math.min(2600, velocity));
      if (pointerId != null && root.releasePointerCapture) {
        try { root.releasePointerCapture(pointerId); } catch (err) { /* yut */ }
      }
      pointerId = null;
    }

    root.addEventListener('pointerdown', onDown);
    root.addEventListener('pointermove', onMove, { passive: true });
    root.addEventListener('pointerup', onUp);
    root.addEventListener('pointercancel', onUp);
    root.addEventListener('pointerleave', onUp);

    // Sürükleme sırasında bağlantı/görsel sürüklemesi devreye girmesin.
    root.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    /* Sürükleyip bıraktıktan sonra tıklama tetiklenmesin: kullanıcı rayı
       kaydırmak isterken yanlışlıkla ürüne gitmesin. */
    root.addEventListener(
      'click',
      function (e) {
        if (moved > 8) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    if (pauseOnHover) {
      root.addEventListener('pointerenter', function () { hovering = true; });
      root.addEventListener('pointerleave', function () { hovering = false; });
    }

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var ratio = setWidth ? offset / setWidth : 0;
        build();
        offset = ratio * setWidth;
        normalize();
        draw();
      }, 180);
    });

    build();
    draw();
    requestAnimationFrame(loop);

    /* Yazı tipleri geç yüklenirse genişlik değişir; bir kez daha ölç. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        var ratio = setWidth ? offset / setWidth : 0;
        build();
        offset = ratio * setWidth;
        normalize();
        draw();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-marquee]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
